import { slice, doCheckout, alignetCheckout } from './checkout.slice';
export { doCheckout, alignetCheckout };
export default slice.reducer;
